import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layer, Line } from 'react-konva';
import {
  emitLineLenght,
  endMeasuring,
  resetMeasurement,
  showScaleLine,
  startMeasuring,
} from '../../actions/scaleline-actions';
import { GLOBAL_PROJECT_TYPE_CHAMBER } from '../../lib/types';

import { mouseClickMeasure } from '../../actions/measuretool-actions';

class ScaleLine extends Component {
  state = {
    measuring: false,
    mouseClickMeasure: false,
    step: 0,
    tempScaleLine: {
      active: true,
      points: [],
    },
  };

  componentDidMount() {
    /* get stage and layer references */
    let stage = this.lineNode.getStage();
    stage.on('click.scaleline', this.handleMouseClick.bind(this));
    stage.on('mousemove.scaleline', this.handleMouseLockedMove.bind(this));
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.active !== this.props.active &&
      prevProps.points !== this.props.points &&
      this.props.points.length === 0
    ) {
      this.setState({ measuring: false });
      this.setState({ mouseClickMeasure: false });
      this.setState({ step: 0 });
    }
  }

  /**
   * Engages the mouse click and locks or unlocks the mouse
   */
  handleMouseClick() {
    if (!this.state.mouseClickMeasure && this.props.active) {
      // first click starts mouse lock
      this.handleMouseLock();
      this.setState({ mouseClickMeasure: true });
      this.setState({ step: 1 });
      this.props.mouseClickMeasure(true);
    } else if (this.state.mouseClickMeasure && this.props.active) {
      if (this.state.step === 1) {
        // second click ends mouse lock
        this.setState({ tempScaleLine: { active: true, points: this.props.points }, step: 2 });
        this.handleMouseUnlock();
        this.props.showScaleLine(this.state.tempScaleLine);
      } else if (this.state.step === 2) {
        // third click resets measure ruler
        this.setState({ mouseClickMeasure: false, step: 0 });
        this.props.mouseClickMeasure(false);
        this.setState({ tempScaleLine: { active: false, points: [] } });
        this.props.showScaleLine(this.state.tempScaleLine);
      }
    }
  }

  /**
   * Handles mouse locking when ruler draw is enabled
   */
  handleMouseLock() {
    if (this.props.active) {
      let layer = this.lineNode.getLayer();
      const mousePosition = this.getMousePosition();

      /* trigger the start measure action */
      this.props.startMeasuring(mousePosition.x, mousePosition.y);
      /* the the measuring state */
      this.setState({ measuring: true });
      /* do batch draw */
      layer.batchDraw();
    }
  }

  /**
   * Draws the ruler main line while the mouse is locked
   */
  handleMouseLockedMove() {
    if (this.state.measuring && this.props.active) {
      let layer = this.lineNode.getLayer();
      const mousePosition = this.getMousePosition();

      /* set temporary second point while drawing */
      let points = this.lineNode.points();
      /* remove last two coordinates and push new ones */
      points.splice(2, 2, mousePosition.x, mousePosition.y);
      /* add points to line */
      this.lineNode.points(points);
      /* do batch draw */
      layer.batchDraw();
    }
  }

  /**
   * Handles mouse unlocking when ruler has being drawn, and it stopped by a second click
   */
  handleMouseUnlock() {
    if (this.props.active) {
      let layer = this.lineNode.getLayer();
      let mousePosition = this.getMousePosition();
      /* get current points */
      let points = this.lineNode.points();
      /* calculate line lenght */
      let pixels = Math.sqrt(Math.pow(mousePosition.x - points[0], 2) + Math.pow(mousePosition.y - points[1], 2)) + 1;

      let ratio = this.props.scaleValue / pixels;
      /* validate pixels > value */
      if (ratio < 0.02 || ratio / this.props.scaleValue >= 0.9) {
        alert(`Feet to pixel ratio is too small, resulting drawing would be uninterpretable.`);
      } else {
        /* emit the line length to other components */
        this.props.emitLineLenght(Number(pixels.toFixed(2)));

        console.log(
          `%c <<< scaleline >>> ${pixels.toFixed(2)}`,
          'color:lightyellow; background-color:darkred; fontsize:20px;',
        );

        /* trigger the start measure action */
        this.props.endMeasuring(mousePosition.x, mousePosition.y);
      }
      /* reset measurement mechanism */
      this.props.resetMeasurement();
      /* the the measuring state */
      this.setState({ measuring: false });
      /* do batch draw */
      layer.batchDraw();
    }
  }

  /**
   * Retu8rns mouse position
   * @returns {{x: number, y: number}}
   */
  getMousePosition() {
    const { viewportScaleX: scaleX, viewportScaleY: scaleY } = this.props;

    let stage = this.props.stageNode.getStage();

    return {
      x: stage.getPointerPosition().x / scaleX - stage.x() / scaleX,
      y: stage.getPointerPosition().y / scaleY - stage.y() / scaleY,
    };
  }

  /**
   * React render
   * @returns {JSX.Element}
   */
  render() {
    return (
      <Layer>
        <Line
          visible={this.props.active}
          points={this.props.points}
          stroke="red"
          strokeWidth={2}
          lineCap="round"
          lineJoin="round"
          dash={[5, 5]}
          ref={(node) => {
            this.lineNode = node;
          }}
        />
      </Layer>
    );
  }
}

const mapStateToProps = (state) => {
  const projectType = state.globals.projectType;
  let viewportScaleX, viewportScaleY;

  if (projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
    viewportScaleX = state.viewport.scaleX;
    viewportScaleY = state.viewport.scaleY;
  } else {
    viewportScaleX = state.viewport.scaleXPipes;
    viewportScaleY = state.viewport.scaleXPipes;
  }

  return {
    stageNode: window.konvaStage,
    active: state.scaleline.active,
    points: state.scaleline.points,
    scaleValue: state.globals.scaleValue,
    viewportScaleX: viewportScaleX,
    viewportScaleY: viewportScaleY,
  };
};

const mapDispatchToProps = {
  startMeasuring,
  endMeasuring,
  emitLineLenght,
  resetMeasurement,
  mouseClickMeasure,
  showScaleLine,
};
/* export this contained component */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScaleLine);



// WEBPACK FOOTER //
// ./src/components/Drawings/scaleline.js